import { Chart as ChartJS } from 'chart.js';

export const overviewColors = {
  product: '#F3A1B8',
  material: '#5467B2',
  future: '#19CEB8',
  marker: '#189AE3',
};

export const ChartViewOptions = [
  { text: 'Year view', value: 12 },
  { text: '2 Years view', value: 24 },
  { text: '5 Years view', value: 60 },
];

export interface DataPoint {
  date: string;
  product: number;
  material: number;
  future: number;
} //std. ERW pipe

const productHistoryJson: Record<string, string> = {
  anyProduct: '/assets/json/FM-ERW-standard-pipe.json',
  erwPipe: '/assets/json/ErwPipe.json',
};

export const fetchJson = async (jsonUrl: string): Promise<DataPoint[]> => {
  try {
    const response = await fetch(jsonUrl);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const dataPoints: DataPoint[] = await response.json();

    return dataPoints;
  } catch (error: any) {
    console.error('err', error);
    throw error;
  }
};

const getFromDate = (monthsCount: number): Date => {
  const today = new Date();

  const fromMonth = today.getMonth() - (monthsCount % 12);
  const fromYear = today.getFullYear() - monthsCount / 12;

  return new Date(fromYear, fromMonth, today.getDate());
};

export const fetchDataPoints = async (productId: string, monthsCount: number): Promise<DataPoint[]> => {
  const jsonUrl = productHistoryJson[productId] || productHistoryJson.anyProduct;

  const dataPoints = await fetchJson(jsonUrl);

  const fromDate = getFromDate(monthsCount);

  return dataPoints.filter(({ date }) => new Date(date) >= fromDate).reverse();
};

export type ChartDragging = ChartJS<'line'> & {
  isDragging?: boolean;
  dragPoint?: { x: number; y: number };
  clicked?: { x: number; topY: number; bottomY: number };
};
